import type { X57VspFidelity } from "./x57VspParameters";

export interface X57VspSource {
  catalogKey: string;
  modelId: string;
  fileName: string;
  label: string;
  shareUrl: string;
  fidelity: X57VspFidelity;
}

/** Path-safe identities for the three real OpenVSP Airshow files recovered for FXC-9009. */
export const X57_VSP_SOURCES: readonly X57VspSource[] = [
  {
    catalogKey: "fleet_x57maxwell",
    modelId: "O7tkehqCAO0ftHdQLkpL",
    fileName: "x57maxwell.vsp3",
    label: "OpenVSP Airshow · X-57 Maxwell",
    shareUrl: "https://airshow.openvsp.org/vsp/O7tkehqCAO0ftHdQLkpL",
    fidelity: "simple",
  },
  {
    catalogKey: "fleet_x57maxwellsimplifiedcrmv441",
    modelId: "i56JLAVRtS2cQKKmK9LH",
    fileName: "x57maxwellsimplifiedcrmv441.vsp3",
    label: "OpenVSP Airshow · X-57 Maxwell simplified CRM v4.4.1",
    shareUrl: "https://airshow.openvsp.org/vsp/i56JLAVRtS2cQKKmK9LH",
    fidelity: "simplified-crm-v4.4.1",
  },
  {
    catalogKey: "fleet_x57maxwelldetailedcrmv441",
    modelId: "6ILKWji5SEmzxnk1oCu1",
    fileName: "x57maxwelldetailedcrmv441.vsp3",
    label: "OpenVSP Airshow · X-57 Maxwell detailed CRM v4.4.1",
    shareUrl: "https://airshow.openvsp.org/vsp/6ILKWji5SEmzxnk1oCu1",
    fidelity: "detailed-crm-v4.4.1",
  },
] as const;

export const X57_DEFAULT_VSP_SOURCE = X57_VSP_SOURCES[0]!;
export const X57_DEFAULT_MODEL_NAME = "NASA X-57 Maxwell" as const;
